export default {
  props: {
    // 标记渲染出来的所有东西都是readonly的，globle.less:66修改了部分readonly样式
    readonly: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    formItems: {
      type: Array,
      default: () => []
    }
  }
}